import { useState, useContext } from "react";
import { ThemeContext } from "../Helper/Context";
const useFetch = (URL) => {
  const [response, setResponse] = useState(null);
  // const [apiName, setApiName] = useState(null)
  const { setShowLoader } = useContext(ThemeContext);
  const doFetch = (url, endpointname, internalcall, urlparams, body, textRes, loader) => {
    setShowLoader(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");

    let bodyData = JSON.stringify({
      integrationcode: "PERFECTGYMAPI",
      endpointname: endpointname,
      internalcall: internalcall,
      useheadervariables: true,
      urlparams: urlparams,
      body: body,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: bodyData,
      redirect: "follow",
    };

    // console.log(bodyData);
    console.log(requestOptions);
    fetch(url, requestOptions)
      .then((response) => {
        // console.log(response);
        if (textRes === undefined) {
          return response.json();
        } else {
          return response.text();
        }
      })
      .then((result) => {
        console.log(endpointname, result);
        setResponse(result);
        if (loader) {
          setShowLoader(false);
        }
      })
      .catch((error) => {
        alert(error);
        // setShowLoader(false);
      });
    // setResponse(url);
  };

  return [{ response, setResponse }, doFetch];
};

export default useFetch;
